
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"badesulRole"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"education"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"race"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"motherName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fatherName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occupation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"familiaryPep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentIssuingBody"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rgNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rgIssuingBody"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relationshipWithGovernment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relationshipWithGovernmentDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"naturalityCity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isNaturalized"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasAnotherSociety"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isIndividualEmployer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"societyData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annualIncomeValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annualIncomeBaseDate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":561}};
    doc.loc.source = {"body":"fragment AdditionalInfo on User {\n  additionalInfo {\n    gender\n    badesulRole\n    education\n    race\n    motherName\n    fatherName\n    occupation\n    maritalStatus\n    nationality\n    pep\n    familiaryPep\n    documentType\n    documentNumber\n    documentIssuingBody\n    documentDate\n    rgNumber\n    rgIssuingBody\n    relationshipWithGovernment\n    relationshipWithGovernmentDescription\n    naturalityCity\n    isNaturalized\n    countryOfOrigin\n    hasAnotherSociety\n    isIndividualEmployer\n    societyData\n    annualIncomeValue\n    annualIncomeBaseDate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AdditionalInfo"] = oneQuery(doc, "AdditionalInfo");
        
